import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import moment from "moment";

import CurrencyFormat from "react-currency-format";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

class ManageDeclarations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      userToDeleteId: null,
      active: true,
      declarationData: null,
      id: null,
      showreject: false,
      search_event: "",
      data: null,
    };
  }

  componentDidMount() {
    // this.props.fetchUsers()
    // this.props.getCustomerData();
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/declaration/get/all`, config)
      .then((res) => {
        //console.log("res",res);
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          //debugger;
          this.setState({
            declarationData: res.data.data.data,
            data: res.data.data.data,
          });
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let self = this;
    let column = [
      {
        Header: "Actions",
        accessor: "actions",
        width: 120,
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              <Tooltip title="View">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    let id = props.original._id;
                    this.props.history.push(`/admin/viewDeclaration/${id}`);
                  }}
                >
                  <Icon>visibility</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Profile",
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.profile_pic
          )
            return (
              <img
                className={props.original.user ? "profile_pic" : null}
                src={props.original.user.profile_pic}
              />
            );
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Firstname",
        width: 150,
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.first_name
          )
            return <span>{props.original.user.first_name}</span>;
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Lastname",
        width: 150,
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.last_name
          )
            return <span>{props.original.user.last_name}</span>;
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Username",
        width: 150,
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.user &&
            props.original.user.user_name
          )
            return <span>{props.original.user.user_name}</span>;
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Declaration Name",
        width: 150,
        accessor: "name",
      },
      {
        Header: "No of Members",
        width: 150,
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.family_members &&
            props.original.family_members.length > 0
          )
            return <span>{props.original.family_members.length}</span>;
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Flight Name and No",
        width: 250,
        Cell: (props) => {
          if (
            props &&
            props.original &&
            props.original.flight &&
            props.original.flight.length > 0
          )
            return (
              <span>
                {props.original.flight[0].name +
                  ", " +
                  props.original.flight[0].flight_id}
              </span>
            );
          else {
            return <span></span>;
          }
        },
      },
      {
        Header: "Travel Date",
        width: 180,
        accessor: "travel_date",
        Cell: (props) => {
          return (
            props.original &&
            moment(props.original.travel_date)
              .add(4, "h")
              .format("DD MMM YYYY, h:mm a")
          );
        },
      },
      {
        Header: "Amount Due",
        accessor: "amount_due",
        Cell: (props) => {
          let value = props.original.amount_due.toString();

          let value2 = value.split(".");
          console.log(value2);

          if (value2.length === 2 && value2[1].length === 1) {
            let final = value + "0";
            console.log("lllllllllll", final);
            return (
              <CurrencyFormat
                value={final}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          } else {
            console.log("ppppppppppppp");
            return (
              <CurrencyFormat
                value={props.original.amount_due}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            );
          }
        },
        width: 120,
      },
      {
        Header: "Custom's Status",
        accessor: "status",
        width: 120,
      },
      {
        Header: "Payment Status",
        accessor: "payment_status",
        width: 140,
      },
      {
        Header: "Delete Request Status",
        accessor: "request_delete",
        width: 200,
        Cell: (props) => {
          if (props.original.request_delete == "notRequested") {
            return <span>Not Requested</span>;
          } else if (props.original.request_delete == "accept") {
            return <span>Accepted</span>;
          } else if (props.original.request_delete == "reject") {
            return <span>Rejected</span>;
          }
        },
      },
    ];
    return column;
  };

  render() {
    const { classes } = this.props;
    const {
      showWarning,
      data,
      search_event,
      userToDeleteId,
      declarationData,
      showreject,
    } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                <TextField
                  id="standard-search"
                  label="Search by Username , Declaration Name or Declaration Holder (FirstName + LastName)"
                  name="search_event"
                  type="search"
                  fullWidth
                  value={search_event}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState(
                      {
                        declarationData: data,
                      },
                      () => {
                        const newwebinarData = this.state.declarationData.filter(
                          (item) =>
                            item.name
                              .toLowerCase()
                              .includes(value.toLowerCase()) ||
                            (item &&
                              item.user &&
                              item.user.user_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase())) ||
                            (item &&
                              item.user &&
                              item.user.first_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase())) ||
                            (item &&
                              item.user &&
                              item.user.last_name
                                .toLowerCase()
                                .includes(value.toLocaleLowerCase()))
                        );
                        this.setState({
                          declarationData: newwebinarData,
                          search_event: value.toLowerCase(),
                        });
                      }
                    );
                  }}
                  margin="normal"
                />
                <ReactTable
                  data={declarationData ? declarationData : []}
                  columns={this.getUserTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Customers found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to delete this Declaration?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            let id = this.state.id;
            // let body = {
            //   id: id
            // };
            axios
              .delete(`${domain}/declaration/delete/${id}`, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("Declaration Deleted Successfully!");
                  this.setState({
                    showreject: false,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {});
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageDeclarationsComponent = withStyles(extendedTablesStyle)(
  ManageDeclarations
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageDeclarationsComponent);
